import { z } from "zod";

/*
  COMBO TIERS. A combo is a run of right answers in a row. It is display only:
  it never changes the questions, the clock, the score, damage or coins, so
  trials stay the honest measure. The marks and words here decide when the
  badge appears and when it steps up a tier, with a bigger pop, a word and a
  burst of sparkles. Above the top mark the badge keeps counting but the
  effects stay at the top tier, so a long run never turns into a light show.

  `colour` is a CSS colour, or "rank" for the colour of the rank in play (the
  rank being trialled, or the fighter's rank in a battle).
*/

const TierSchema = z.object({
  /** The run length this tier starts at. */
  from: z.number().int().min(2),
  /** Shown for a moment when the tier is reached. Short and warm. */
  word: z.string().min(1).max(12),
  colour: z.string().min(1),
  /** Sparkles in the burst when the tier is reached; 0 for none. */
  sparkles: z.number().int().nonnegative(),
  /** A flash over the whole question card when the tier is reached. */
  flash: z.boolean(),
});
export type ComboTier = z.infer<typeof TierSchema>;

const TiersSchema = z
  .array(TierSchema)
  .min(1)
  .refine((tiers) => tiers.every((t, i) => i === 0 || t.from > tiers[i - 1]!.from), {
    message: "combo tiers must start at increasing marks",
  });

/** What the badge is called on screen. */
export const COMBO_WORD = "Combo";

export const COMBO_TIERS: readonly ComboTier[] = TiersSchema.parse([
  { from: 3, word: "Nice!", colour: "var(--bamboo)", sparkles: 0, flash: false },
  { from: 5, word: "Combo!", colour: "var(--gold)", sparkles: 6, flash: false },
  { from: 8, word: "On fire!", colour: "#f26b1d", sparkles: 10, flash: false },
  { from: 12, word: "Ninja!", colour: "rank", sparkles: 14, flash: true },
]);
